import { useCallback } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import { buildDetailRecordFunctionPayload, type HeliosFunctionContext } from 'utils/helios/buildHeliosFunctionPayload';
import { useHeliosFunctionRunner } from './useHeliosFunctionRunner';
import type { FunctionModalConfirmData } from 'components/user/DummyHelios/Functions/modals/FunctionModal';

interface UseHeliosDetailRecordFunctionsProps {
  datasourceId: string;
  templateViewId: string;
  moduleId: string;
  recordId: string;
  masterRecordId: string;
  getColumnValues: () => Record<string, string | null>;
  navigate: NavigateFunction;
  getNavigateState?: () => Record<string, unknown> | undefined;
  onSuccess?: () => void | Promise<void>;
}

export const useHeliosDetailRecordFunctions = ({
  datasourceId,
  templateViewId,
  moduleId,
  recordId,
  masterRecordId,
  getColumnValues,
  navigate,
  getNavigateState,
  onSuccess,
}: UseHeliosDetailRecordFunctionsProps) => {
  const buildPayload = useCallback(
    (args: { context: HeliosFunctionContext; request?: FunctionModalConfirmData['request'] }) =>
      buildDetailRecordFunctionPayload({
        ...args,
        datasourceId,
        recordId,
        masterRecordId,
        getColumnValues,
      }),
    [datasourceId, getColumnValues, masterRecordId, recordId]
  );

  return useHeliosFunctionRunner({
    templateViewId,
    moduleId,
    navigate,
    getNavigateState,
    buildPayload,
    onSuccess,
  });
};
